import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import CompanyModel from "../../../../../viewModels/Company/CompanyModel";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  clientProfile: CompanyModel;
} = {
  loading: true,
  loadingData: true,
  clientProfile: undefined!,
};

const clientProfilePageSlice = createSlice({
  name: "clientProfile",
  initialState,
  reducers: {
    loadClientProfile(state) {
      state.loadingData = true;
    },
    loadClientProfileSuccess(state, action: PayloadAction<CompanyModel>) {
      state.loading = false;
      state.loadingData = false;
      state.clientProfile = action.payload;
    },
    loadClientProfileError(state) {
      state.loading = false;
      state.loadingData = false;
    },

    updateClientProfile(state, _action: PayloadAction<CompanyModel>) {
      state.loadingData = true;
    },
    updateClientProfileSuccess(state, action: PayloadAction<CompanyModel>) {
      state.loadingData = false;
      state.clientProfile = action.payload;
    },
    updateClientProfileError(state) {
      state.loadingData = false;
    },
  },
});

export default clientProfilePageSlice;
